// React context that scopes CachedThumb to the active user + trip without
// prop-drilling through DayCardGallery → DayBucketTree → tile.
import { createContext, useContext, type ReactNode } from "react";

type Scope = { userId: string | null; tripId: string | null };

const Ctx = createContext<Scope>({ userId: null, tripId: null });

export function LibraryCacheScope({
  userId,
  tripId,
  children,
}: Scope & { children: ReactNode }) {
  return <Ctx.Provider value={{ userId, tripId }}>{children}</Ctx.Provider>;
}

export function useLibraryCacheScope(): Scope {
  return useContext(Ctx);
}
